import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateVesselComponent } from './create-vessel.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreateVesselComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    CreateVesselComponent
  ]
})
export class CreateVesselModule { }
